export default __webpack_public_path__ + "static/media/icon-down.0c77426d.svg";